import React from 'react';
import { observer } from "mobx-react-lite";
import { IntInputField } from '../shared/IntInputField';
import { FloatInputField } from '../shared/FloatInputField';
import { useTranslation } from 'react-i18next';
import { combatStore } from '../../stores/CombatStore';
export const GlobalCombatVariablesEditor = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    config
  } = combatStore;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", null, t("editor.combat_configuration_global_variables")), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_short_phase_duration"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FloatInputField, {
    value: config.shortPhaseDuration,
    onChange: config.setShortPhaseDuration.bind(config),
    onlyPositive: true
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_long_phase_duration"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FloatInputField, {
    value: config.longPhaseDuration,
    onChange: config.setLongPhaseDuration.bind(config),
    onlyPositive: true
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_phase_transition_duration"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FloatInputField, {
    value: config.phaseTransitionDuration,
    onChange: config.setPhaseTransitionDuration.bind(config),
    onlyPositive: true
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_player_health"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(IntInputField, {
    value: config.playerHealth,
    onChange: config.setPlayerHealth.bind(config),
    onlyPositive: true
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_short_player_attack_phase_damage_multiplier"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FloatInputField, {
    value: config.shortPlayerAttackPhaseDamageMultiplier,
    onChange: config.setShortPlayerAttackPhaseDamageMultiplier.bind(config),
    onlyPositive: true
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_long_player_attack_phase_damage_multiplier"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FloatInputField, {
    value: config.longPlayerAttackPhaseDamageMultiplier,
    onChange: config.setLongPlayerAttackPhaseDamageMultiplier.bind(config),
    onlyPositive: true
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_bonus_damage"), " (0..1):"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FloatInputField, {
    value: config.bonusDamage,
    onChange: config.setBonusDamage.bind(config),
    onlyPositive: true,
    min: 0,
    max: 1
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_long_defense_phase_damage_factor"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FloatInputField, {
    value: config.longDefensePhaseDamageFactor,
    onChange: config.setLongDefensePhaseDamageFactor.bind(config),
    onlyPositive: true
  }))))));
});